import { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import { GROWTHPAL_ACCESS_TOKEN } from './store/authStore'
import Layout from './components/layout/Layout'
import LandingPage from './pages/LandingPage'
import CompanyDashboard from './pages/CompanyDashboard'
import CompanyDetail from './pages/CompanyDetail'

function ProtectedRoute({ children }) {
  const token =
    useAuthStore((state) => state.growthpalToken) ||
    localStorage.getItem(GROWTHPAL_ACCESS_TOKEN)

  if (!token) {
    return <Navigate to="/" replace />
  }

  return children
}


function AuthInitializer({ children, onInitialized }) {
  const initAuth = useAuthStore((s) => s.initAuth)
  const isAuthReady = useAuthStore((s) => s.isAuthReady)
  const navigate = useNavigate()
  useEffect(() => {

    let mounted = true

    const init = async () => {
      try {
        const success = await initAuth()

        if (!mounted) return

        onInitialized?.(success)

        if (success && window.location.pathname === '/') {
          navigate('/companies', { replace: true })
        }
      } catch (error) {
        if (!mounted) return
        onInitialized?.(false)
      }
    }

    init()

    return () => {
      mounted = false
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  if (!isAuthReady) {
    return <div>Authenticating...</div>
  }

  return children
}
function AppContent() {
  const [authInitialized, setAuthInitialized] = useState(false)

  return (
    <AuthInitializer onInitialized={() => setAuthInitialized(true)}>
      {authInitialized ? (
        <Routes>
          {/* Landing page - token entry */}
          <Route path="/" element={<LandingPage />} />

          {/* Protected buyer routes */}
          <Route
            path="/companies"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<CompanyDashboard />} />
            <Route path=":companyId" element={<CompanyDetail />} />
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      ) : null}
    </AuthInitializer>
  )
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  )
}

export default App
